var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"doc-viewer"}},[(_vm.pdf)?_c('vue-pdf-app',{staticStyle:{"height":"94vh","flex":"1","margin":"1%"},attrs:{"pdf":_vm.pdf,"config":_vm.config,"fileName":_vm.title,"title":true},on:{"pages-rendered":_vm.pagesRenderedHandler}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }